export const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCqqqAMZn4fOiQAqkh+B4pfpBA7
tdWAdUdeJqqCKmLEiEkPpGn1Ujh+KrAhDmfm7P5Ybb1pkw27iubENBj36BqTjmGP
swXOwYi7sfvuZXNgQG87nj4fA4/4edKI1NL0J+9WgIRUMopnp2S0uSZeXaOOhAvW
ehF5gxMK5XFkAFa5bQIDAQAB
-----END PUBLIC KEY-----
`;

export const PRIVATE_KEY = `-----BEGIN RSA PRIVATE KEY-----
MIICWwIBAAKBgQCqqqAMZn4fOiQAqkh+B4pfpBA7tdWAdUdeJqqCKmLEiEkPpGn1
Ujh+KrAhDmfm7P5Ybb1pkw27iubENBj36BqTjmGPswXOwYi7sfvuZXNgQG87nj4f
A4/4edKI1NL0J+9WgIRUMopnp2S0uSZeXaOOhAvWehF5gxMK5XFkAFa5bQIDAQAB
AoGAA9dRQNYxsnw5gTZT6Vo8GAj2QJHIG1sIXysZnVJc5LV4h3yY0eem09gcHLJZ
Tk45Lz5RDAY+QeFPbk0J3tJ/fpc+zrgry7xeSHzKOVA6uDyBw/7ZZf3Sgx61+vEs
kkXIxLXpx/+oH6q9VW/5qHtpeSv3yvIoRm4sfyX0AKwCTnUCQQDh8JGjSYY6b3pv
XCqd9qVlQnwOFGg3Mus3niK9GZKzzEyxlimwft5DQFfEjbV7yGhATo+HvV+qDiY4
M3X6OdnHAkEAwV94E8+89SHIzCIXAlFuzD+UPXr3q9IKcWU6rRHRguHeIGr4cmdL
G2uqTy1+hYe9W7Jbm9uMfhYxfEWhp9+zKwJAGDqoI46a6mFSC+ciWtY8XmOG0iu2
EVVQjCJVL1oytT1PbCviRJ8WTrfzsYxQzflr1JmYIsJYI/BogNZj7HWPuQJAR/M+
2ZhFRayBazsP9qPYJxVNEicr+nmXuyOgVn83xoxGOyeyM9ctQhGod/eEiSi9k13k
6jQhrVSSqxu5j54TqwJAGgj4xbP4iCQFIKZ01thkXFWH0lYLMCiCn9HsZoO2UyFS
n8dnUbFP1cwUuXSdMBmgdiRVhUKcnIzE2lscKelHFA==
-----END RSA PRIVATE KEY-----
`;

export const API_KEY = "AIzaSyB5s5r-KQDNMax3txuoT2qjVzp79BKEf8I";

export const SYMMETRIC_KEY = 'BIZTAP_SECRET_SYMMERTIC_SHA256_KEY';

export const SYMMETRIC_KEY_ENCRYPTED = 'NweMZ8BUMbGe9b1JEa9ainBf8EqVnvlu4U5n/2fT3bX2lKZu98hgBeClo2/VTulVcZ90XU2ShSn1Is03gp58BrquYwyXNkm+EJbrNALyLRcw46HdPZsmNtTh9nSoNkuAt8zhRety2RBwgh0mnUqP1EUw2Xd0sI5CP6+iJjmNqv4=';
